import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-18" data-mp="pjzlbb82zkbs">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="pj6de6xdyos2">
        <div className="mx-auto max-w-xl text-center" data-id="element-20" data-mp="avcw8hsnje7d">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-21" data-mp="auteb1304ptc">
            Solo per oggi
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-22" data-mp="1un3xo2lo5ye">
            <span aria-hidden="true" data-id="element-23" data-mp="5x1lm4uj8zo3">🎁 </span>Ricevi i 5 Bonus Strategici{' '}
            <span className="italic text-grape" data-id="element-24" data-mp="3o24um0nmdvts">«Salva-Docente»</span>
          </h2>
          <p className="mt-3 text-sm text-navy/60" data-id="element-25" data-mp="3t0g76j5aukfp">
            Valore totale:{' '}
            <span className="font-bold text-navy/40 line-through" data-id="element-26" data-mp="3t2j4zpcp1huz">€76</span> —
            Inclusi a <span className="font-bold text-tangerine" data-id="element-27" data-mp="1m85khim8hkio">€0</span> nel
            tuo ordine
          </p>
        </div>

        <ol className="mt-12 space-y-6" data-id="element-28" data-mp="3ieg6r1msq2zs">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex flex-col items-center gap-6 rounded-3xl bg-white p-6 text-center shadow-soft sm:flex-row sm:gap-9 sm:p-8 sm:text-left" data-id="element-29" data-mp="3icljhgo1xysj" data-mpi={index}>
              <img src={bonus.cover} alt="" className="h-56 w-44 shrink-0 object-contain sm:h-64 sm:w-52" data-id="element-30" data-mp="3r5gihsmxey9v" />

              <div className="sm:flex-1" data-id="element-31" data-mp="3n5oiw5fig2gn">
                <div className="flex flex-wrap items-center justify-center gap-3 sm:justify-start" data-id="element-32" data-mp="2zfkgg1e268r8">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-tangerine font-display text-sm font-bold text-white" data-id="element-33" data-mp="2ughbegy2w2j9">
                    {index + 1}
                  </span>
                  <span className="rounded-full bg-navy-light px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-navy/70" data-id="element-34" data-mp="33hfemx0p060s">
                    Valore {bonus.value}
                  </span>
                  <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-teal" data-id="element-35" data-mp="irg9swey2d2e">
                    Incluso gratis
                  </span>
                </div>

                <h3 className="mt-4 font-display text-xl font-black leading-snug tracking-tight text-navy sm:text-2xl" data-id="element-36" data-mp="3hhzjrant5xa8">
                  {bonus.title}
                </h3>
                <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-navy/60 sm:mx-0" data-id="element-37" data-mp="3lke7a82f9l7u">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}